import { render, staticRenderFns } from "./transferCollapse.vue?vue&type=template&id=08680121&scoped=true"
import script from "./transferCollapse.vue?vue&type=script&lang=js"
export * from "./transferCollapse.vue?vue&type=script&lang=js"
import style0 from "./transferCollapse.vue?vue&type=style&index=0&id=08680121&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08680121",
  null
  
)

export default component.exports